import React, { FC } from 'react'
import { useReactiveVar } from '@apollo/client'
import { Button } from '@wmgtech/legato'

import useLocalizer from 'modules/Globalize/serviceHooks/useLocalizer'
import { activeProjectVar } from 'modulesCommon/store'

import './LocalizeProjectButton.scss'
import { Can } from 'shared/abilities/Can'

const LocalizeProjectButton: FC = () => {
  const activeProject = useReactiveVar(activeProjectVar)
  const { localizeButtonView, onLocalizeProject, isButtonVisible } = useLocalizer({ project: activeProject })

  return isButtonVisible ? (
    <Can I={'localize'} a={'GlobalProject'}>
      <Button
        label={localizeButtonView.label}
        {...(localizeButtonView.secondaryIcon && { secondaryIcon: localizeButtonView.secondaryIcon })}
        colorType="secondary-black"
        containerStyle="outline"
        className="localize-project__button"
        size="md"
        data-edit-mode
        onClick={onLocalizeProject}
      />
    </Can>
  ) : null
}

export default LocalizeProjectButton
